import axios from 'axios';

const baseDomain = process.env.VUE_APP_BACKEND_URL;
const baseUrl = `${baseDomain}/api`;
const axiosInstance = axios.create({
    baseURL: baseUrl,
    withCredentials: true
});

// Add a request interceptor
axiosInstance.interceptors.request.use(function (config) {
    // eslint-disable-next-line no-undef
    sso.appendHeadersToRequest(function(key, value) {
        config.headers[key] = value;
    });
    return config;
});

axiosInstance.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.data && typeof response.data.status !== 'undefined' && response.data.status === 'redirect') {
        location.href = response.data.url;
    } else {
        return response;
    }
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});

export default axiosInstance;